export const minecraft1213 = {
  version: '1.21.3',
  title: 'Bundles of Bravery',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/MCV_falldrop_launch_editorial_1170x500.jpg',
  releases: [
    {
      id: "1B4DY6fn",
      version: "1.0.4",
      date: "May 26, 2025",
      changelog: "Versión estable para Minecraft 1.21.3",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.3",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};